import { Box, Flex, GridItem, Heading, HStack, Image, SimpleGrid, Span, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'



const OurCover = () => {

    const gradient1 = useColorModeValue('blue.50', 'blue.800')
    const gradient2 = useColorModeValue('green.50', 'green.700')
    const cardColor = useColorModeValue('white', 'gray.900')
    const textGhost = useColorModeValue('gray.800', 'gray.200')
    const colorRightElement =useColorModeValue('blue.50', '')
    const colorRight =useColorModeValue('blue.500', 'white')
    const borderColor = useColorModeValue('gray.100', 'gray.800')
    const {t} = useTranslation()

    const Vodafone = 'https://images.directunlocks.com/images/Vodafone-Logo-New.png'
    const Mtn = 'https://www.gsma.com/get-involved/gsma-membership/wp-content/uploads/2014/06/MTN_2022_Logo_Black_RGB-Fond-jaune-square.png'
    const Orange = 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Orange_logo.svg/800px-Orange_logo.svg.png'
    const Moov = 'https://cdn.sanity.io/images/c09exlh6/production/836be1f330f1b4ad414190fccf504ae6658f5537-512x512.png'
    const Wave = 'https://pbs.twimg.com/profile_images/1846916870219141120/E477p8xw_400x400.jpg'
    const paypal = 'https://www.paypalobjects.com/webstatic/mktg/logo/pp_cc_mark_111x69.jpg'
    const mpesa = 'https://faidihr.com/uploads/events/MPESA-API-Integration-Services-kenya06.17.31.jpg'
    const airtel = 'https://www.jobinrwanda.com/sites/default/files/styles/medium/public/employer_logos/logo_1136584422.png?itok=c8R-48ou'
    const movitel = 'https://upload.wikimedia.org/wikipedia/commons/f/f7/Movitel-Logo.jpg'
    const free = 'https://www.sagapresse.com/wp-content/uploads/2022/01/67034-615-124-1024x576.jpg'
    const tigo = 'https://images.seeklogo.com/logo-png/56/1/tigo-money-logo-png_seeklogo-565877.png'
    const halotel = 'https://ik.imagekit.io/tp/20230713-halotel-logo-new.jpg?tr=w-800,h-456'
    const Zamtel = 'https://pbs.twimg.com/media/GKAE_BmWoAAlGn2.png'

    const MotionGridItem = motion.create(GridItem)
    const MotionSimpleGrid = motion.create(SimpleGrid)

    const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
        staggerChildren: 0.1, // Délai entre chaque item
        },
    },
    };

    const itemVariants = {
    hidden: { y: 20, opacity: 0, scale: 0.95 },
    visible: { y: 0, opacity: 1, scale: 1 },
    };
    
    const ArrayOfCoverage = [
        {
            country: 'Cameroon',
            device : 'XAF',
            flag: 'cm',
            operators: [
                {
                    image: Mtn,
                    name: 'MTN Cameroun'
                },
                {
                    image: Orange,
                    name: 'Orange Cameroun'
                }
            ]
        },

        {
            country: 'Cote d\'ivoire',
            device : 'XOF',
            flag: 'ci',
            operators: [
                {
                    image: Mtn,
                    name: 'MTN cote d\'ivoire'
                },
                {
                    image: Orange,
                    name: 'Orange cote d\'ivoire'
                },
                {
                    image: Wave,
                    name: 'Wave cote d\'ivoire'
                },
            ]
        },

        {
            country: 'Benin',
            device : 'XOF',
            flag: 'bj',
            operators: [
                {
                    image: Mtn,
                    name: 'MTN benin'
                },
                {
                    image: Moov,
                    name: 'Moov benin'
                }
            ]
        },

        {
            country: 'Burkina Faso',
            device : 'XOF',
            flag: 'bf',
            operators: [
               {
                    image: Orange,
                    name: 'Orange burkina Faso'
                },
                {
                    image: Moov,
                    name: 'Moov burkina Faso'
                }
            ]
        },

        {
            country: 'congo RDC',
            device : 'XOF',
            flag: 'cg',
            operators: [
               {
                    image: Orange,
                    name: 'Orange congo RDC'
                },
                {
                    image: Moov,
                    name: 'Moov congo RDC'
                }
            ]
        },
        {
            country: 'Ethiopie',
            device : 'XOF',
            flag: 'et',
            operators: [
               {
                    image: mpesa,
                    name: 'Mpesa ethiopie'
                },
            ]
        },
        {
            country: 'Gabon',
            device : 'XAF',
            flag: 'ga',
            operators: [
               {
                    image: airtel,
                    name: 'Airtel gabon'
                },
                {
                    image: Moov,
                    name: 'Moov gabon'
                }
            ]
        },
        {
            country: 'Ghana',
            device : 'GHS',
            flag: 'gh',
            operators: [
               {
                    image: Mtn,
                    name: 'Mtn Ghana'
                },
                {
                    image: Vodafone,
                    name: 'Vodafone Ghana'
                },
                {
                    image: airtel,
                    name: 'Airtel Ghana'
                },
            ]
        },
        {
            country: 'Comores',
            device : 'USD',
            flag: 'km',
            operators: [
               {
                    image: paypal,
                    name: 'Paypal ou carte bancaire'
                },
                
            ]
        },
        {
            country: 'Kenya',
            device : 'KES',
            flag: 'ke',
            operators: [
               {
                    image: mpesa,
                    name: 'Mpesa Kenya'
                }, 
            ]
        },
        {
            country: 'Lesotho',
            device : 'LSL',
            flag: 'ls',
            operators: [
               {
                    image: mpesa,
                    name: 'Mpesa Lesotho'
                }, 
            ]
        },
        {
            country: 'Malawi',
            device : 'MWK',
            flag: 'mw',
            operators: [
               {
                    image: airtel,
                    name: 'Airtel Malawi'
                },
            ]
        },
        {
            country: 'Mali',
            device : 'XOF',
            flag: 'ml',
            operators: [
               {
                    image: Orange,
                    name: 'Orange Mali'
                },
               {
                    image: Moov,
                    name: 'Moov Mali'
                },
            ]
        },
        {
            country: 'Mozambique',
            device : 'MZN',
            flag: 'mz',
            operators: [
               {
                    image: movitel,
                    name: 'Movitel Mozambique'
                },
               {
                    image: Vodafone,
                    name: 'Vodafone Mozambique'
                },
            ]
        },
        
        {
            country: 'Nigeria',
            device : 'USD',
            flag: 'ng',
            operators: [
               {
                    image: paypal,
                    name: 'Paypal ou carte bancaire'
                },
            ]
        },

        {
            country: 'Ouganda',
            device : 'UGX',
            flag: 'ug',
            operators: [
               {
                    image: Mtn,
                    name: 'MTN Ouganda'
                },
               {
                    image: airtel,
                    name: 'Airtel Ouganda'
                },
            ]
        },
        {
            country: 'Republique centrafricaine',
            device : 'XAF',
            flag: 'cf',
            operators: [
               {
                    image: Orange,
                    name: 'Orange RCA'
                },
            ]
        },
        {
            country: 'Republique du congo',
            device : 'XAF',
            flag: 'cg',
            operators: [
               {
                    image: Mtn,
                    name: 'Mtn Congo'
                },
               {
                    image: airtel,
                    name: 'Airtel Congo'
                },
            ]
        },
        {
            country: 'Rwanda',
            device : 'RWF',
            flag: 'rw',
            operators: [
               {
                    image: Mtn,
                    name: 'Mtn Rwanda'
                },
               {
                    image: airtel,
                    name: 'Airtel Rwanda'
                },
            ]
        },
        {
            country: 'Senegal',
            device : 'XOF',
            flag: 'sn',
            operators: [
               {
                    image: Orange,
                    name: 'Orange Senegal'
                },
               {
                    image: free,
                    name: 'Free Senegal'
                },
            ]
              
        },
        {
            country: 'Sierra Leone',
            device : 'SLL',
            flag: 'sl',
            operators: [
               {
                    image: Orange,
                    name: 'Orange Sierra Leone'
                },
            ]
              
        },
        {
            country: 'Tanzanie',
            device : 'TZS',
            flag: 'tz',
            operators: [
               {
                    image: airtel,
                    name: 'Airtel Tanzanie'
                },
               {
                    image: Vodafone,
                    name: 'Vodafone Tanzanie'
                },
               {
                    image: tigo,
                    name: 'Tigo Tanzanie'
                },
               {
                    image: halotel,
                    name: 'Halotel Tanzanie'
                },
            ]
              
        },
        {
            country: 'Tchad',
            device : 'XAF',
            flag: 'td',
            operators: [
               {
                    image: Moov,
                    name: 'Moov Tchad'
                },
            
            ]
              
        },
        {
            country: 'Togo',
            device : 'XAF',
            flag: 'tg',
            operators: [
               {
                    image: Moov,
                    name: 'Moov Togo'
                },
            
            ]
              
        },
        {
            country: 'Zambie',
            device : 'ZMW',
            flag: 'zm',
            operators: [
               {
                    image: Mtn,
                    name: 'Mtn Zambie'
                },
               {
                    image: airtel,
                    name: 'Airtel Zambie'
                },
               {
                    image: Zamtel,
                    name: 'Zamtel Zambie'
                },
            
            ]
              
        },
        {
            country: 'Autre pays',
            device : 'USD',
            flag: 'eu',
            operators: [
               {
                    image: paypal,
                    name: 'Paypal ou carte bancaire'
                },
        
            ]
              
        },
    ]


    return (
        <Flex
            px={{md: 'inherit', '2xl': "19%", base: 4}}
            py={{'2xl' :20, base: 10}}
            overflow={'hidden'}
            position={'relative'}
        >
            <Box w={'full'} id='geographic-coverage'>
                <Flex gap={{ md: 10, base: 4 }} align={'center'} flexDir={'column'}>
                    <Heading maxW={'500px'} textAlign={'center'} fontFamily={'Poppins'} letterSpacing={-1.5} lineHeight={1.1} fontSize={{ md: '4xl', '2xl': '5xl', base: '2xl' }} >
                            {t('geographicCoverageTitleServiceOne')}
                    </Heading>
                    <Text fontSize={{'2xl': 'xl', base: 'md'}} textAlign={'center'} maxW={'600px'}>
                            {t('geographicCoverageDescriptionServiceOne')}
                    </Text>
                </Flex>


                <MotionSimpleGrid mt={24} variants={containerVariants}
                 gap={5} columns={{'2xl' : 4, base: 1}}
                 initial="hidden"
                    whileInView="visible"
                 >
                    {ArrayOfCoverage.map((elt, index) => 
                    <MotionGridItem variants={itemVariants} key={index} minH={'200px'} bgColor={cardColor} boxShadow={'md'} rounded={24}>
                        <Box 
                        roundedTop={24}
                        bgGradient={'to-r'}
                        gradientFrom={gradient1}
                        gradientTo={gradient2}
                        minH={'80px'}
                        p={4}
                        px={6}
                        display={'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        >
                            <HStack gap={4}>
                                <Image rounded={'full'}
                                    src={`https://flagcdn.com/w320/${elt.flag}.png`}
                                    alt={elt.country}
                                    boxSize={'40px'}
                                />
                                <Box>
                                    <Heading fontFamily={'Onest'}>
                                        {elt.country}
                                    </Heading>
                                    <Text  fontSize={'sm'} color={textGhost}>
                                        <Span fontFamily={'Outfit'}>{elt.operators.length}</Span> {t('operator')}
                                    </Text>
                                </Box>
                            </HStack>

                            <Box p={2} bgColor={colorRightElement} rounded={'full'}>
                                <Text color={colorRight} fontSize={'sm'} fontFamily={'Outfit'} fontWeight={500}>{elt.device}</Text>
                            </Box>
                        </Box>

                        <SimpleGrid gap={3} columns={2} w={'full'} p={4} px={4}>
                            {elt.operators.map((eltOp, index)=>
                                <HStack key={index} border={'1px solid'} borderColor={borderColor} gap={4} p={2} rounded={10}>

                                    <Image rounded={10}
                                        w={'50px'}
                                        src={eltOp.image}
                                    />

                                    <Text color={textGhost} lineClamp={2} lineHeight={1.2} fontFamily={'Outfit'}>
                                       {eltOp.name}
                                    </Text>

                                </HStack>
                            )}
                        </SimpleGrid>

                    </MotionGridItem>)}
                </MotionSimpleGrid>

            </Box>
        </Flex>
  )
}

export default OurCover